/**
 * description
 *
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var LE = require('app');
    var Loader = require("ui/loader/Loader");
    var errorCodes = require("registration-assets/data/errorCodes.json");

    // MODEL
    var UpgradePlanModel = require("registration-models/UpgradePlanModel");

    // COLLECTION
    var PlansCollection = require('registration-collections/PlansCollection');

    // VIEW
    var Page = require("ui.components/page/Page");
    var PlanSelectionView = require("registration-views/plan-selection/PlanSelectionView");
    var AssistedSaleView = require("registration-views/plan-selection/AssistedSaleView");
    // TODO(oded): rename to ConfirmationView
    var BuyNowConfirmationView = require("registration-views/buy-now/BuyNowConfirmationView");

    // UTILS
    var RegistrationStorageUtil = require("registration-utils/RegistrationStorageUtil");

    var ChangePlanController = {};
    function moduleDefiniton(LERegistration, LE, Backbone, Marionette, $, _) {
        ChangePlanController = Marionette.Controller.extend({

            initialize: function (options) {
                LERegistration.logger.info("start", "ChangePlanController:initialize");
                this.vent = options.vent;
                this.controller = options.controller;

                this.flowModel = this.controller.flowModel;

                LERegistration.vent.on('planSelectionView:next', _.bind(this._planSelectionNextClick,this));

            },

            //-------------------------------------------------------------------------

            routeBack: function() {
                this.controller.routeToPrevious();
            },

            showPlanSelectionView:  function (args) {
                this.controller.showLoader();
                this.flowModel.set({"currency": "USD"}); //TODO remove it when select option is enabled
                this.flowModel.set({"language": args.language});
                if(LE.sessionManager && LE.sessionManager.getAccountId()) {
                    this._createAndShowPlanSelectionView();
                } else {
                    LE.logout();
                }

            },

            showPlanSelectionCheckout:  function (){
                LERegistration.logger.info("Clicked 'Next' in the 'Choose a plan' page");
                var isTrialDeferred= this.controller.billingManager.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                    if (isTrial) {
                        if(this.flowModel.get("planName")) {
                            if (this.flowModel.get("creditCardRef") || this.controller.isShowDetails){ //means that it is not the first time we enter the page, so we need to clear the ccRef and retain the values.
                                LERegistration.logger.info("unsetting creditCardRef when we arrive to the page second time (Browser back button)", "ChangePlanController:showPlanSelectionCheckout");
                                this.flowModel.unset("creditCardRef");
                                this.controller.billingManager.fetchZuoraIframeSource(this.flowModel, true, null, "changePlan");
                            } else {
                                this.controller.billingManager.fetchZuoraIframeSource(this.flowModel, false, null, "changePlan");
                            }
                        } else {
                            LERegistration.logger.info("navigate to changePlanSelection", "ChangePlanController:showPlanSelectionCheckout");
                            LERegistration.router.navigate("changePlanSelection");
                        }
                    } else {
                        this.routeBack();
                    }
                    LERegistration.logger.info("end", "ChangePlanController:showPlanSelectionCheckout");
                }, this));
            },

            showPlanSelectionConfirmation:  function (){
                LERegistration.logger.info("Clicked 'Next' in the Zuora billing details page", "ChangePlanController:showPlanSelectionConfirmation");
                var isTrialDeferred= this.controller.billingManager.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                    if (isTrial) {
                        if(this.flowModel.get("creditCardRef")) {
                            this.controller.isShowDetails = true;
                            this.controller.showLoader();
                            this.getCcDetails();
                        } else {
                            LERegistration.logger.info("navigate to changePlanCheckout", "ChangePlanController:showPlanSelectionConfirmation");
                            this.showPlanSelectionCheckout();
                        }
                    } else {
                        // TODO: Paying confirmation flow
                        this.controller.isShowDetails = true;
                        this.controller.showLoader();
                        this.getCcDetails();
                    }
                    LERegistration.logger.info("end", "ChangePlanController:showPlanSelectionConfirmation");
                }, this));
            },
           
            getCcDetails: function(){
                this.flowModel.unset("creditCardDetails");
                var promises= [];
                promises.push(this.controller.billingManager.getCreditCardDetails(this.flowModel));
                promises.push(this.controller.billingManager.getTerm());
                
                $.when.apply($, promises).then( _.bind(function(flowModel, term){
                    var pagePermutation = Page.PERMUTATION.Custom;
                    if(LE.sessionManager.isAuthenticated()) {
                        pagePermutation = Page.PERMUTATION.Dialog;
                    }
                    var buyNowConfirmationInnerView = new BuyNowConfirmationView({ model: flowModel, flowType: "changePlan", term: term});
                    var buyNowConfirmationView = new Page({
                        moduleName:LERegistration.moduleName,
                        context:LE.context,
                        view: buyNowConfirmationInnerView,
                        permutation: pagePermutation
                    });
                    this.listenTo(buyNowConfirmationInnerView, BuyNowConfirmationView.TRIGGERING.CANCEL_BUTTON_CLICKED, _.bind(function(){
                        this.controller.routeToPrevious();
                    },this));
                    this.listenTo(buyNowConfirmationInnerView, BuyNowConfirmationView.TRIGGERING.CONFIRM_BUTTON_CLICKED, _.bind(function(){
                        this.controller.showLoader();
                        this.confirmPurchase(); //unique to ChangPlanController
                    },this));
                    this.controller.showViewInMainRegion(buyNowConfirmationView);
                    this.controller.closeLoader();
                },this), 
                _.bind(function(message, errorCode){
                    var returnPage = LE.sessionManager.isAuthenticated() ? undefined : RegistrationStorageUtil.CONSTANT.RETURN_PAGE_BUYNOW;
                    this.controller.handleRegistrationError(message, errorCode, returnPage);
                },this));
            },

            confirmPurchase: function (){
                LERegistration.logger.info("Clicked 'Purchase' in the 'Confirm purchase' page", "ChangePlanController:confirmPurchase");
                var upgradePlanModel = new UpgradePlanModel();
                if(this.flowModel.get("crmDetails.website")) {
                    upgradePlanModel.set("accountData.accountCreateData.url", this.flowModel.get("crmDetails.website"));
                }
                if(this.flowModel.get("crmDetails.email")) {
                    upgradePlanModel.set("additionalParams.loggedInUserEmail", this.flowModel.get("crmDetails.email"));
                }
                if(this.flowModel.get("creditCardRef")) {
                    upgradePlanModel.set("registrationData.billingData.ccRef", this.flowModel.get("creditCardRef"));
                }
                if(this.flowModel.get("currency")) {
                    upgradePlanModel.set("registrationData.billingData.currencyCode", this.flowModel.get("currency"));
                }
                if(this.flowModel.get("productName")) {
                    upgradePlanModel.set("registrationData.productData.productName", this.flowModel.get("productName"));
                }
                if(this.flowModel.get("pendingPlan.planType")) {
                    upgradePlanModel.set("registrationData.productData.productType", this.flowModel.get("pendingPlan.planType"));
                }
                if(this.flowModel.get("planName")) {
                    upgradePlanModel.set("registrationData.productData.productRatePlanName", this.flowModel.get("planName"));
                }
                if(this.flowModel.get("crmDetails.firstName")) {
                    upgradePlanModel.set("registrationData.crmData.firstName", this.flowModel.get("crmDetails.firstName"));
                }
                if(this.flowModel.get("crmDetails.lastName")) {
                    upgradePlanModel.set("registrationData.crmData.lastName", this.flowModel.get("crmDetails.lastName"));
                }

                var isTrialDeferred= this.controller.billingManager.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                    upgradePlanModel.set("registrationData.flow", isTrial ? "Subscription" : "Amendment");

                    upgradePlanModel.save(null, {
                        success: _.bind(function (model, response, options){
                            //success upgrade tier
                            LERegistration.logger.info("SUCCESS upgrade account", "ChangePlanController:confirmPurchase");

                            // turn off the trial flag
                            LE.context.set("user.isTrialAttrSet", true);
                            LE.context.set("user.isTrial", false);
                            if(isTrial){
                                // refresh page to My Account bookmark
                                LE.isSilentLeave = true;
                                if(window.history && window.history.pushState){
                                    //change url without doing any rendering, the rendering will happen upon window reload
                                    window.history.pushState({},"","#registration!myAccount");
                                }else{
                                    LERegistration.router.navigate("myAccount");
                                }
                                LE.navigator.reload();
                                return;
                            }

                            // update models
                            LE.BillingInformation(true);
                            
                            LERegistration.notifier.showSuccess(LE.translator.translate("LERegistration.planSelection.upgrade.success"));

                            this.flowModel.unset("currentPlan"); // so that MyPlan pane will rerender with the amended plan
                            this.flowModel.unset("pendingPlan");

                            // refetch crm details, trial to paying will now fetch Zuora details, 
                            // and ammending user will fetch Zuora updated payer details
                            this.flowModel.unset("crmDetails");
                            // refetch plans to get current and ammended plans
                            this.flowModel.unset("collection");
                            this.flowModel.unset("creditCardRef");
                            
                            this.controller.billingManager.routeToHomeForMyAccountFailWhenJustPurchased= true;
                            
                            if(this.controller.myAccountViewPage){
                                this.controller.myAccountViewPage.close();
                                this.controller.myAccountViewPage= undefined;
                            }
                            
                            this.controller.closeLoader();
                            LERegistration.router.navigate("myAccount");
                            
                        }, this),
                        error: _.bind(function (data, response, options){
                            var message= "Failed upgrading account.";
                            var errorCode= errorCodes.changePlanUpgradeFailed;
                            this.controller.handleRegistrationError(message, errorCode, "changePlanSelection", null, response);
                        }, this)
                    });
                }, this));
            },
            /**********************PRIVATE METHODS***********************/

            _createAndShowPlanSelectionView:  function () {
                var isTrialDeferred= this.controller.billingManager.isTrial();
                $.when(isTrialDeferred)
                .done(_.bind(function(isTrial){
                    var promises= [];
                    //prefetch crm details (will be used in next screens)
                    promises.push(this.controller.billingManager.getBillingCRMDetails(this.flowModel));
                    //fetch plans, if already exists will avoid a call to the network
                    promises.push(this.controller.billingManager.getPlans(this.flowModel));
                    if(!isTrial){
                        promises.push(this.controller.billingManager.getCreditCardDetails(this.flowModel));
                    }
                    $.when.apply($, promises)
                    .done( _.bind(function(){
                        // check case when already ammended, if so open chat
                        var plans= this.flowModel.get("collection");
                        var planAmendement= plans && plans.findWhere({"planType" : PlansCollection.TYPES.AMENDMENT});
                        if(planAmendement){
                            LERegistration.notifier.showError(LE.translator.translate("LERegistration.planSelection.already.amended"));
                            this.controller.closeLoader();
                            this.controller.openChat();
                            LERegistration.router.navigate("myAccount");
                            return;
                        }

                        var isTrial= LE.context.get("user.isTrial");

                        var planSelectionView, planSelectionPage, plansCollection= this.flowModel.get('collection');
                        var personalPlan= plansCollection.findWhere({"planType": PlansCollection.TYPES.PERSONAL});
                        this.flowModel.set("hasPersonal", personalPlan !== undefined);
                        if(personalPlan){
                            planSelectionView = new AssistedSaleView({
                                model: this.flowModel,
                                collection: plansCollection,
                                controller: this.controller,
                                mode: isTrial ? PlansCollection.MODES.TRIAL : PlansCollection.MODES.PAYING
                            });
                            planSelectionPage  = new Page({
                                moduleName:LERegistration.moduleName,
                                context:LE.context,
                                view: planSelectionView,
                                header: {
                                    title: LE.translator.translate("LERegistration.assistedSale.title"),
                                    description: LE.translator.translate("LERegistration.assistedSale.description")
                                },
                                permutation: Page.PERMUTATION.Dialog
                            });
                            this.listenTo(planSelectionView, AssistedSaleView.TRIGGERING.CANCEL_BUTTON_CLICKED, _.bind(function(){
                                this.routeBack();
                            },this));
                            this.listenTo(planSelectionView, AssistedSaleView.TRIGGERING.CHAT_BUTTON_CLICKED, _.bind(this._onChatButtonClick,this));
                        }else{
                            planSelectionView = new PlanSelectionView({
                                model: this.flowModel,
                                collection: plansCollection,
                                controller: this.controller,
                                mode: isTrial ? PlansCollection.MODES.TRIAL : PlansCollection.MODES.PAYING
                            });
                            planSelectionPage  = new Page({
                                moduleName:LERegistration.moduleName,
                                context:LE.context,
                                view: planSelectionView,
                                header: {
                                    title: LE.translator.translate("LERegistration.planSelection.title"),
                                    description: LE.translator.translate("LERegistration.planSelection.description")
                                },
                                permutation: Page.PERMUTATION.Dialog
                            });
                            this.listenTo(planSelectionView, PlanSelectionView.TRIGGERING.CANCEL_BUTTON_CLICKED, _.bind(function(){
                                this.routeBack();
                            },this));
                            this.listenTo(planSelectionView, PlanSelectionView.TRIGGERING.CHAT_BUTTON_CLICKED, _.bind(this._onChatButtonClick,this));
                        }

                        this.controller.showViewInMainRegion(planSelectionPage);
                        this.controller.closeLoader();
                    },this))
                    .fail(_.bind(function(message, errorCode, response){ 
                        message= "Cannot proceed to showing plan selection view." + message; 
                        if(errorCode === errorCodes.ccDetailsFetchFailed || errorCode === errorCodes.ccDetailsEmptyValues){
                            LERegistration.notifier.showError(LE.translator.translate("LERegistration.planSelection.noPaymentMethod"));
                            this.controller.openChat({ message: message });
                            this.controller.closeLoader();
                            LE.router.navigateBack();
                        }else{
                            this.controller.handleRegistrationError(message, errorCode, LE.sessionManager.isAuthenticated() && "changePlanSelection", null, response);
                        }
                    },this));

                }, this));
            },

            _planSelectionNextClick:  function (planModel) {
                var selectedPlanName= planModel.get('productRatePlanName');
                var selectedProductName= planModel.get('productName');

                this.flowModel.set({"planName": selectedPlanName});
                this.flowModel.set({"productName": selectedProductName}); 

                var isTrialDeferred= this.controller.billingManager.isTrial();
                $.when(isTrialDeferred)
                .done(_.bind(function(isTrial){
                    this.flowModel.set("pendingPlan", planModel.toJSON());

                    if(isTrial) {
                       this.showPlanSelectionCheckout();
                    } else {
                       this.showPlanSelectionConfirmation();
                    }
                }, this));
                
            },

            _onChatButtonClick:  function () {
                this.controller.openChat();
            }

        });
    }
    LE.module("LERegistration", moduleDefiniton);
    
    return ChangePlanController;
});